import React from "react";

const BillingFooter = ({ total, onAddRow,onEditRow, onSave }) => {
  return (
    <footer className="billing-footer">
      
      <div>
        <button className="btn btn-primary me-2" onClick={onAddRow}>
          New 
        </button>
        <button className="btn btn-primary me-2" onClick={onEditRow}>
          Edit 
        </button>
        <button className="btn btn-success" onClick={onSave}>
          Save 
        </button>
       
      </div>
      <div className="total">
        <h3>
          Total: <span>{total.toFixed(2)}</span>
        </h3>
      </div>
    </footer>
  );
};

export default BillingFooter;
